"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setInternalAppTaskNode = void 0;
var firefly_utilities_ts_1 = require("firefly-utilities-ts");
var firefly_utilities_helper_ts_1 = require("firefly-utilities-helper-ts");
var task_status_1 = __importDefault(require("../constants/task-status"));
var firefly_shared_ts_1 = require("firefly-shared-ts");
function setInternalAppTaskNode(json, systemTime) {
    var id, initiatedTimestamp, name, sessionTaskObj, status, taskNode;
    taskNode = firefly_utilities_ts_1.Utilities.getValueFromObject(json, "task", null);
    if (!(0, firefly_utilities_helper_ts_1.isNullOrUndefined)(taskNode) && !firefly_utilities_ts_1.Utilities.isEmptyObject(taskNode)) {
        sessionTaskObj = firefly_utilities_ts_1.FFPersistenceManager.getSessionStorageValue('task');
        id = firefly_utilities_ts_1.Utilities.getValueFromObject(sessionTaskObj, 'id', null);
        initiatedTimestamp = firefly_utilities_ts_1.Utilities.getValueFromObject(sessionTaskObj, 'initiatedTimestamp', null);
        name = firefly_utilities_ts_1.Utilities.getValueFromObject(taskNode, 'name', null);
        status = firefly_utilities_ts_1.Utilities.getValueFromObject(taskNode, 'status', null);
        if ((0, firefly_utilities_helper_ts_1.isNullOrUndefined)(id)) {
            id = firefly_shared_ts_1.Event.createEventId();
            initiatedTimestamp = systemTime;
            name = firefly_utilities_ts_1.Utilities.getValueFromObject(taskNode, 'name', null);
            firefly_utilities_ts_1.FFPersistenceManager.setSessionStorageValue('task', { id: id, initiatedTimestamp: initiatedTimestamp, name: name });
        }
        taskNode = { id: id, initiatedTimestamp: initiatedTimestamp, name: name };
        if (!(0, firefly_utilities_helper_ts_1.isNullOrUndefined)(status) && (status === task_status_1.default.SUCCESS || status === task_status_1.default.FAIL ||
            status === task_status_1.default.CANCELLED)) {
            firefly_utilities_ts_1.FFPersistenceManager.setSessionStorageValue('task', null);
        }
    }
    return taskNode;
}
exports.setInternalAppTaskNode = setInternalAppTaskNode;
